export default [
  {
    path: '/communication',
    name: 'communication',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'communication',
      crud: {
        pageTitle: 'app.communication.title',
        showCard: false,
        pageContent: () => import('App/communication/Communication.vue'),
      },
    },
  },
  {
    path: '/communication/draft',
    name: 'communicationDraft',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'communication',
      crud: {
        btnText: 'app.communication.add',
        newRouteName: 'communicationAdd',
        pageTitle: 'app.communication.title',
        pageContent: () => import('App/communication/CommunicationList.vue'),
        filterComponent: () => import('Support/components/crud/OnlySearchFilter.vue'),
        filterDialogComponent: () => import('App/communication/components/CommunicationFilter.vue'),
      },
    },
  },
  {
    path: '/communication/logs',
    name: 'communicationLogs',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'communication',
      crud: {
        btnText: 'app.communication.add',
        newRouteName: 'communicationAdd',
        pageTitle: 'app.communication.title',
        pageContent: () => import('App/communication/CommunicationList.vue'),
        filterComponent: () => import('Support/components/crud/OnlySearchFilter.vue'),
        filterDialogComponent: () => import('App/communication/components/CommunicationFilter.vue'),
      },
    },
  },
  {
    path: '/communication/add',
    name: 'communicationAdd',
    component: () => import('App/communication/CommunicationForm.vue'),
    meta: {
      itemActive: 'communication',
    },
  },
  {
    path: '/communication/:id',
    name: 'communicationEdit',
    component: () => import('App/communication/CommunicationForm.vue'),
    meta: {
      itemActive: 'communication',
    },
  },
];
